export default __webpack_public_path__ + "static/media/tent_light.6b1220f8.png";